import styled from "styled-components";
import { Link } from "react-router-dom";

export const Container = styled.div`
  min-height: 692px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 0;
  overflow: scroll;
  background: #129bc0;
`;

export const FormWrap = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 20px;

  @media screen and (max-width: 360px) {
    height: 80%;
  }
`;

export const Icon = styled(Link)`
  margin-left: 32px;
  margin-top: 32px;
  text-decoration: none;
  color: #fff;
  font-weight: 700;
  font-size: 12px;

  @media screen and (max-width: 360px) {
    margin-left: 16px;
    margin-top: 8px;
  }
`;

export const LogoContainer = styled.div`
  height: 40px;
  width: 120px;
  filter: brightness(50%);
`;

export const FormContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 360px) {
    padding: 10px;
  }
`;

export const Form = styled.form`
  background: #010101;
  max-width: 400px;
  height: auto;
  width: 100%;
  z-index: 1;
  display: grid;
  margin: 0 auto;
  padding: 40px 30px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);

  @media screen and (max-width: 360px) {
    padding: 32px 32px;
    height: 640px;
    width: 340px;
  }
`;

export const FormH1 = styled.h1`
  margin-bottom: 20px;
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  text-align: center;
`;

export const FormLabel = styled.label`
  margin-bottom: 8px;
  font-size: 14px;
  color: #fff;
  @media screen and (max-width: 300px) {
    width: 280px;
  }
`;

export const FormInput = styled.input`
  padding: 8px 16px;
  margin-bottom: 24px;
  border: none;
  border-radius: 4px;
  @media screen and (max-width: 300px) {
    width: 280px;
  }
`;

export const FromSelectInput = styled.select`
  padding: 8px 16px;
  margin-bottom: 32px;
  border: none;
  border-radius: 4px;
  @media screen and (max-width: 360px) {
    width: 280px;
  }
`;

export const FormButton = styled.button`
  background: #129bc0;
  padding: 8px 0;
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 15px;
  cursor: pointer;
  @media screen and (max-width: 360px) {
    width: 280px;
  }
`;

export const Text = styled.span`
  text-align: center;
  margin-top: 12px;
  color: #fff;
  font-size: 14px;
`;
